export const SKILLS_LIBRARY = [
  // Programming Languages
  "Java", "Python", "JavaScript", "TypeScript", "C++", "C#", "Go", "Rust",
  "Kotlin", "Swift", "Ruby", "PHP", "Scala", "R", "MATLAB", "Perl",

  // Frontend
  "React", "Angular", "Vue.js", "Next.js", "HTML", "CSS", "Tailwind CSS",
  "Bootstrap", "Redux", "GraphQL", "REST APIs", "Webpack", "Vite",
  "jQuery", "SASS", "LESS",

  // Backend
  "Node.js", "Spring Boot", "Django", "FastAPI", "Flask", "Express.js",
  "Laravel", "Ruby on Rails", "ASP.NET", "Hibernate", "Spring MVC",
  "Microservices", "gRPC", "WebSockets",

  // Databases
  "SQL", "MySQL", "PostgreSQL", "MongoDB", "Redis", "Elasticsearch",
  "Cassandra", "DynamoDB", "Oracle", "SQLite", "Firebase", "Supabase",
  "Neo4j", "InfluxDB",

  // Cloud & DevOps
  "AWS", "Azure", "Google Cloud", "Docker", "Kubernetes", "Jenkins",
  "GitHub Actions", "CI/CD", "Terraform", "Ansible", "Linux", "Nginx",
  "Apache", "Helm", "ArgoCD", "Prometheus", "Grafana",

  // Data & AI
  "Machine Learning", "Deep Learning", "TensorFlow", "PyTorch", "Pandas",
  "NumPy", "Scikit-learn", "Data Analysis", "Data Engineering", "Spark",
  "Hadoop", "Airflow", "dbt", "Power BI", "Tableau", "OpenAI API",

  // Mobile
  "Android", "iOS", "React Native", "Flutter", "Xamarin", "Ionic",

  // Testing
  "JUnit", "Selenium", "Playwright", "Cypress", "Jest", "Pytest",
  "TestNG", "Postman", "JMeter", "Mockito",

  // Architecture & Practices
  "System Design", "SOLID Principles", "Design Patterns", "TDD",
  "Agile", "Scrum", "Git", "JIRA", "Confluence", "Code Review",
  "API Design", "Event-Driven Architecture", "Domain-Driven Design",

  // Security
  "OAuth", "JWT", "SSL/TLS", "OWASP", "Penetration Testing",
  "Cryptography", "IAM", "Zero Trust",

  // IT Infrastructure & Administration
  "Windows Administration", "Windows Server", "Active Directory", "Azure AD",
  "Entra ID", "O365", "Office 365", "Microsoft 365", "Exchange", "IT Infrastructure",
  "PowerShell", "Group Policy", "DNS", "DHCP", "TCP/IP", "VPN", "Firewall",
  "SCCM", "Intune", "VMware", "Hyper-V", "Citrix", "ServiceNow", "ITIL",
  "Networking", "Help Desk", "System Administration", "Linux Administration",
];

export const searchSkills = (query) => {
  if (!query || query.trim().length < 1) return [];
  const q = query.toLowerCase().trim();
  return SKILLS_LIBRARY
    .filter((s) => s.toLowerCase().includes(q))
    .slice(0, 8); // max 8 suggestions
};

// Find known skills mentioned in free text (fallback when AI suggestions are unavailable)
export const extractSkillsFromText = (text) => {
  if (!text) return [];
  const esc = (x) => x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return SKILLS_LIBRARY.filter((skill) =>
    new RegExp('(^|[^A-Za-z0-9+#])' + esc(skill) + '($|[^A-Za-z0-9+#])', 'i').test(text)
  ).slice(0, 10);
};
